import { CheckTemplateIntervalType } from "../../settings/checktemplates/types/CheckTypes.interfaces"

export enum CheckType {
  Service = 0,
  Inspection = 1
}

export enum CheckStatus {
  OK,
  DueSoon,
  Overdue
}

// Base properties shared by all checks
interface BaseCheckProperties {
  vehicleId: number
  vehicleRegNumber: string
  vehicleInternNumber: string
  checkTemplateId: number
  checkTemplateName: string
  checkTemplateIntervalId: number
  checkTemplateIntervalType: CheckTemplateIntervalType
  isOverdue: boolean
  status: CheckStatus | string | number
  checkType: CheckType
  earliestDueDate?: string
  valueUntilService?: number
  currentOdometerReading?: number
  nextValue?: string
  lastCompletedValue?: string
}

// Inspection booking properties
interface InspectionBookingProperties {
  hasInspectionBooking?: boolean
  inspectionBookingId?: number
  inspectionBookingDate?: string
  inspectionBookingRemark?: string
  vehicleCheckHistoryStatus?: string // 'Booked', 'Waiting', 'Passed', 'Failed'
}

export interface UpcomingCheck extends BaseCheckProperties, InspectionBookingProperties { }

export interface IntervalDetail {
  id: number
  intervalType: CheckTemplateIntervalType
  intervalValue: number
  nextValue?: string
  lastCompletedValue?: string
  status?: CheckStatus | number
}

export interface UpcomingService extends UpcomingCheck {
  checkType: CheckType.Service
  intervalType: string
  intervalValue: number
  intervals?: IntervalDetail[]
}

export interface UpcomingInspection extends UpcomingCheck {
  checkType: CheckType.Inspection
}

// Union type
export type ServiceOrInspection = UpcomingService | UpcomingInspection

// Type guard functions
export const isUpcomingInspection = (item: ServiceOrInspection): item is UpcomingInspection => {
  return item.checkType === CheckType.Inspection
}

export const isUpcomingService = (item: ServiceOrInspection): item is UpcomingService => {
  return item.checkType === CheckType.Service
}
export interface NumberTypeSelectorOption {
  value: string;
  label: string;
}

export interface NumberTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: NumberTypeSelectorOption[];
  label?: string;
  maxWidth?: number;
}

export interface ViewData {
  value: string
  label: string
}
export interface SwitchOption {
  params?: any
  view: string
  setView: (data: string) => void
  viewList: ViewData[]
  onInspectionChange?: () => void
}